var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tx_link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.URL
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-left",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }])
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("UTXO was created on")]), _vm._v(" " + _vm._s(_vm.chain) + " " + _vm._s(_vm._f("fromNow")(_vm.timestamp)) + " ")]), _c('p', [_c('span', {
    staticClass: "light"
  }, [_vm._v("Tx ID: ")]), _c('span', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.txID))])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }